// ============================================================
// Panel formlarinda ortak Yup kurallari.
//
// Sayfalarin cogunda dogrulama ya hic yoktu ya da anlamsiz
// `Yup.string(3).required(...)` seklindeydi (string() parametre almaz).
// Ayni kurallar burada toplandi ki tum duzenleme ekranlari ayni davransin.
// ============================================================
import * as Yup from "yup";

// Bos metin girisleri number/date alanlarinda NaN'a donusup
// "gecersiz" hatasi veriyor; once null'a ceviriyoruz.
const emptyToNull = (value, original) =>
  original === "" || original === null || typeof original === "undefined"
    ? null
    : value;

/** Zorunlu metin alani. */
export const requiredText = (label, { min = 2, max = 250 } = {}) =>
  Yup.string()
    .trim()
    .min(min, `${label} en az ${min} karakter olmalı`)
    .max(max, `${label} en fazla ${max} karakter olabilir`)
    .required(`${label} zorunludur`);

/** Istege bagli metin alani. */
export const optionalText = (label, { max = 1000 } = {}) =>
  Yup.string()
    .trim()
    .nullable()
    .max(max, `${label} en fazla ${max} karakter olabilir`);

/** http(s) ile baslamasi gereken istege bagli adres. */
export const optionalUrl = (label = "Link") =>
  Yup.string()
    .trim()
    .nullable()
    .matches(/^https?:\/\/.+/i, {
      message: `${label} http:// veya https:// ile başlamalı`,
      excludeEmptyString: true,
    });

/** Istege bagli tam sayi (siralama, adet vb.). */
export const optionalInt = (label, { min = 0, max } = {}) => {
  let schema = Yup.number()
    .transform(emptyToNull)
    .nullable()
    .integer(`${label} tam sayı olmalı`)
    .min(min, `${label} en az ${min} olabilir`);
  if (max != null) schema = schema.max(max, `${label} en fazla ${max} olabilir`);
  return schema;
};

/** Istege bagli ondalikli sayi (fiyat, oran vb.). */
export const optionalNumber = (label, { min = 0, max } = {}) => {
  let schema = Yup.number()
    .transform(emptyToNull)
    .nullable()
    .min(min, `${label} en az ${min} olabilir`);
  if (max != null) schema = schema.max(max, `${label} en fazla ${max} olabilir`);
  return schema;
};

/** Istege bagli e-posta. */
export const optionalEmail = (label = "E-posta") =>
  Yup.string()
    .trim()
    .nullable()
    .email(`Geçerli bir ${label.toLocaleLowerCase("tr-TR")} giriniz`);

/** Istege bagli telefon: rakam, bosluk, +, parantez ve tire kabul edilir. */
export const optionalPhone = (label = "Telefon") =>
  Yup.string()
    .trim()
    .nullable()
    .matches(/^[0-9+()\-\s]{7,20}$/, {
      message: `${label} geçerli görünmüyor`,
      excludeEmptyString: true,
    });

/** Harita koordinati. */
export const optionalLatitude = () =>
  Yup.number()
    .transform(emptyToNull)
    .nullable()
    .min(-90, "Enlem -90 ile 90 arasında olmalı")
    .max(90, "Enlem -90 ile 90 arasında olmalı");

export const optionalLongitude = () =>
  Yup.number()
    .transform(emptyToNull)
    .nullable()
    .min(-180, "Boylam -180 ile 180 arasında olmalı")
    .max(180, "Boylam -180 ile 180 arasında olmalı");

export default {
  requiredText,
  optionalText,
  optionalUrl,
  optionalInt,
  optionalNumber,
  optionalEmail,
  optionalPhone,
  optionalLatitude,
  optionalLongitude,
};
